/* @flow */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import StarRating from '@homeaway/react-star-rating';
import {MoreOrLess} from '@homeaway/react-collapse';
import {Unveil} from '@homeaway/react-unveil';
import type {SearchReview as SearchReviewShape} from '../../queries/searchQuery';
import {Link} from '@homeaway/react-localization-components';

import './SearchReviews.less';

type Props = {
    reviews: SearchReviewShape[]
};

export function SearchReview({
    detailPageUrl,
    reviewHead,
    reviewText,
    reviewCreated,
    reviewArrival,
    reviewRating,
    hitThumbnailUrl
}: SearchReviewShape) {
    return (
        <li className={'SearchReview'} data-wdio={'SearchReview'}>
            <div className={'SearchReview__image-section'}>
                <Link href={detailPageUrl}>
                    <div className={'SearchReview__image'}>
                        <Unveil threshold={400}>
                            <img src={hitThumbnailUrl} alt={reviewHead} />
                        </Unveil>
                    </div>
                </Link>
                <Link
                    className={'SearchReview__image-link'}
                    href={detailPageUrl}
                >
                    <FormattedMessage
                        defaultMessage={'View property'}
                        id={'searchReviewViewProperty'}
                    />
                </Link>
            </div>
            <div className={'SearchReview__info'}>
                <Link
                    className={'h4'}
                    href={detailPageUrl}
                    data-wdio={'SearchReview__headline'}
                >
                    {reviewHead}
                </Link>
                <div className={'SearchReview__info-item'}>
                    <StarRating rating={reviewRating} />
                    <span className="SearchReview__rating-text">
                        <FormattedMessage
                            defaultMessage={`${reviewRating} of 5`}
                            id="reviewRatingText"
                            values={{reviewRating}}
                        />
                    </span>
                </div>
                <div
                    className={
                        'SearchReview__info-item SearchReview__more-or-less'
                    }
                >
                    <MoreOrLess
                        expanderPosition={'inline'}
                        lines={2}
                        moreText={
                            <FormattedMessage
                                defaultMessage={'more'}
                                id={'moreLabelLower'}
                            />
                        }
                    >
                        <p className={'SearchReview__review-text'}>
                            {reviewText}
                        </p>
                    </MoreOrLess>
                </div>
                <div
                    className={
                        'SearchReview__info-item SearchReview__review-dates'
                    }
                >
                    <div className={'SearchReview__submitted-date'}>
                        <FormattedMessage
                            defaultMessage={'Submitted'}
                            id={'searchReviewSubmitted'}
                        />
                        {`: ${reviewCreated}`}
                    </div>
                    <div className={'SearchReview__arrival-date'}>
                        <FormattedMessage
                            defaultMessage={'Stayed'}
                            id={'searchReviewStayLabel'}
                        />
                        {`: ${reviewArrival}`}
                    </div>
                </div>
            </div>
        </li>
    );
}

export default function SearchReviews({reviews}: Props) {
    return (
        <ul className={'SearchReviews'} data-wdio={'SearchReviews'}>
            {reviews.map((review, i) => (
                <SearchReview {...review} key={i} />
            ))}
        </ul>
    );
}
